import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { nominationAPI } from '../../lib/atoNominationAPI';

const ACTION = ['nomination_requested', 'not_found', 're_nomination_required', 'help_requested'];

export const PortalNominationCard = () => {
  const nav = useNavigate();
  const [s, setS] = useState(null);
  useEffect(() => { nominationAPI.my().then((r) => setS({ total: r.entities.length, done: r.entities.filter((e) => ['linked', 'completed'].includes(e.status)).length, todo: r.entities.filter((e) => ACTION.includes(e.status)).length })).catch(() => setS(null)); }, []);
  if (!s || !s.total) return null;
  return (
    <Card data-testid="onboarding-ato-nomination-card"><CardContent className="p-4 flex flex-wrap items-center gap-3">
      <div className="flex-1"><div className="font-medium">Authorise us with the ATO</div>
        <div className="text-sm text-muted-foreground"><b data-testid="onboarding-ato-nomination-progress">{s.done} of {s.total} entities authorised</b>{s.todo ? ` · ${s.todo} need${s.todo === 1 ? 's' : ''} your action` : ''}. This doesn’t hold up your onboarding.</div></div>
      <Button onClick={() => nav('/my-ato-authorisation')} data-testid="onboarding-ato-nomination-start">{s.todo ? 'Start' : 'View'}</Button></CardContent></Card>
  );
};
